import React from "react";
import HeroCTR from "../../components/hero/HeroSectionComp";
import AllPackages from "../../containers/home/AllPackagesCTR";
import ReviewCTR from "../../containers/home/ReviewCTR";
import MemberCTR from "../../containers/about/MemberCTR";
import FindAdventureCTR from "../../containers/home/FindAdventureCTR";

function AboutCTR() {
  return (
    <div>
      <HeroCTR
        img="/images/hero/bg-subheader.jpg"
        heading="About Us"
        para="Journeys That Inspire"
      />

      <div className="mt-12 md:mt-22">
        {/* Section 1 */}
        <div className="flex flex-col md:flex-row gap-4 md:gap-22 items-center justify-between">
          <div
            className="md:flex-1 w-full h-[318px] md:h-[418px] bg-cover bg-top rounded-md"
            style={{ backgroundImage: "url('/images/about/s1.jpg')" }}
          ></div>
          <div className="flex-1">
            <h3 className="text-[20px] md:text-[24px] lg:text-[30px] text-[#666] font-semibold mb-2">
              A Perfect Place Vacation
            </h3>
            <p className="text-[15px] text-[#8C8C8C] max-w-[730px] mb-4">
              Discover unforgettable destinations curated just for you. At Bonvoy Tourism, we believe every journey should be an experience to remember. Whether you seek tranquil beaches, vibrant cities, or hidden gems off the beaten path, we ensure your vacation is seamless, inspiring, and full of wonder.
            </p>
            <p className="text-[13px] text-[#606060] max-w-[730px]">
              Our team of travel experts meticulously plans each trip to combine comfort, adventure, and cultural richness. From carefully selected accommodations to immersive local experiences, we handle the details so you can focus on creating memories that last a lifetime. With Bonvoy Tourism, every vacation is more than a trip—it’s a story waiting to be told.
            </p>
          </div>
        </div>

        {/* Section 2 */}
        <div className="flex flex-col-reverse md:flex-row gap-4 md:gap-22 items-center justify-between mt-4 md:mt-0">
          <div className="flex-1">
            <h3 className="text-[20px] md:text-[24px] lg:text-[30px] text-[#666] font-semibold mb-2">
              About Our Service
            </h3>
            <p className="text-[15px] text-[#8C8C8C] max-w-[730px] mb-4">
              Our services are designed to make travel effortless, enjoyable, and truly unforgettable. We focus on understanding your travel preferences and crafting itineraries that match your dreams, whether it’s a relaxing getaway or an action-packed adventure.
            </p>
            <p className="text-[13px] text-[#606060] max-w-[730px]">
              From personalized travel planning to 24/7 support, Bonvoy Tourism ensures every step of your journey is smooth and stress-free. We partner with trusted local guides and service providers to bring you authentic experiences, insider knowledge, and unparalleled convenience. Your adventure is our priority, and we’re committed to making every trip extraordinary.
            </p>
          </div>
          <div
            className="md:flex-1 w-full h-[318px] md:h-[418px] bg-cover bg-top rounded-md"
            style={{ backgroundImage: "url('/images/about/s2.jpg')" }}
          ></div>
        </div>
      </div>

      <div className="-mx-6 sm:-mx-10 md:-mx-14 lg:-mx-20">
        <AllPackages />
      </div>

      <ReviewCTR />

      <div className="-mx-6 sm:-mx-10 md:-mx-14 lg:-mx-20">
        <MemberCTR />
      </div>

      <div className="-mx-6 sm:-mx-10 md:-mx-14 lg:-mx-20">
        <FindAdventureCTR mt="mt-12 md:mt-22" />
      </div>
    </div>
  );
}

export default AboutCTR;
